export default __webpack_public_path__ + "1f56c9450e80feaa3a7cc653e446b1a2.png";